import { render, staticRenderFns } from "./TempRegistration.vue?vue&type=template&id=1aae9f7a"
import script from "./TempRegistration.vue?vue&type=script&lang=js"
export * from "./TempRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports